import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { EyebrowText, Section, SectionHeadline, LimitedSectionContent, DefinitionTerm, DefinitionDescription } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { FAIRE_VALUES } from "@faire/retailer-visitor-shared/views/careers/__internal__/LifeatFaire/faireValues";
import { StyledCTAButton, SignUpButtonContent, StyledArrowRight } from "@faire/retailer-visitor-shared/views/careers/ViewOpeningsButton";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
var OurValuesSectionBase = function() {
    var _useViewport = useViewport(), isTablet = _useViewport.isTablet, isXLargeDesktop = _useViewport.isXLargeDesktop;
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsxs(Section, {
        id: "values",
        align: "center",
        $withHorizontalPadding: true,
        $withVerticalPadding: true,
        $backgroundColor: Core.surface.inverse,
        children: [
            /*#__PURE__*/ _jsx(LimitedSectionContent, {
                children: /*#__PURE__*/ _jsx(EyebrowText, {
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "inhWvl",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Our Values"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(ResponsiveContent, {
                children: [
                    /*#__PURE__*/ _jsxs(HeadlineContainer, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "3x"
                            }),
                            /*#__PURE__*/ _jsx(SectionHeadline, {
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "c1fqFI",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Faire is being built for entrepreneurs, by entrepreneurs."
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "3x"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subheadingSansMedium",
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "nnhZM1",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Every day is an adventure at Faire. Our core values guide the work we do and the culture we\u2019re building."
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "5x"
                            }),
                            /*#__PURE__*/ _jsx(StyledCTAButton, {
                                linkTo: "https://news.faire.com/2021/11/04/what-defines-faire/",
                                children: /*#__PURE__*/ _jsxs(SignUpButtonContent, {
                                    children: [
                                        /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                            id: "1PJu5p",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "What Defines Faire"
                                                }
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(StyledArrowRight, {})
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Column, {
                        align: isTablet ? "flex-end" : "flex-start",
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "5x"
                            }),
                            FAIRE_VALUES(strictLocalize).map(function(faireValue, index) {
                                return /*#__PURE__*/ _jsxs(React.Fragment, {
                                    children: [
                                        index !== 0 ? /*#__PURE__*/ _jsx(Spacer, {
                                            size: isXLargeDesktop ? "5x" : "4x"
                                        }) : null,
                                        /*#__PURE__*/ _jsx(Value, _object_spread({}, faireValue))
                                    ]
                                }, faireValue.title);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export var OurValuesSection = observer(OurValuesSectionBase);
var ResponsiveContent = styled(LimitedSectionContent).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-daaa6917-0"
})([
    "",
    "{flex-direction:row;}"
], responsiveMediaQueries.desktopAndAbove);
var Value = function(param) {
    var id = param.id, title = param.title, description = param.description;
    return /*#__PURE__*/ _jsxs(ValueDefinitionList, {
        id: id,
        children: [
            /*#__PURE__*/ _jsx(DefinitionTerm, {
                children: title
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(DefinitionDescription, {
                children: description
            })
        ]
    });
};
var ValueDefinitionList = styled.dl.withConfig({
    componentId: "sc-daaa6917-1"
})([
    "max-width:428px;",
    "{max-width:496px;}"
], responsiveMediaQueries.xLargeAndAbove);
var HeadlineContainer = styled(Column).withConfig({
    componentId: "sc-daaa6917-2"
})([
    "",
    "{max-width:252px;}",
    "{max-width:550px;}"
], responsiveMediaQueries.tabletAndBelow, responsiveMediaQueries.desktopAndAbove);
